import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import proToast from '../../functions/toast';
import { HttpClient } from '@angular/common/http';
import { complaintsUrl } from 'src/globals';
import { regionsUrl } from 'src/globals';
import { exchangeUrl } from 'src/globals';

@Component({
  selector: 'app-complaints',
  templateUrl: './complaints.component.html',
  styleUrls: ['./complaints.component.css'],
})
export class ComplaintsComponent implements OnInit {
  showPopup = false;
  loading = false;
  isSending: boolean = false;
  complaintsForm!: FormGroup;
  complaintReference: string = '';
  regions: any[] = [];
  exchanges: any[] = [];
  regionsLoading: boolean = false;
  exchangesLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.complaintsForm = this.fb.group({
      accountName: ['', Validators.required],
      landlineNumber: [''], // Optional field
      mobileNumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      region: [''], // Will store the entire region object
      exchange: [''], // Optional field
      customerFeedback: ['', Validators.required],
      consent: [false, Validators.requiredTrue]
    });

    this.fetchRegions();
  }

  fetchRegions() {
    this.regionsLoading = true;
    this.http.get(regionsUrl)
      .subscribe(
        (response: any) => {
          this.regions = response.data || [];
          this.regionsLoading = false;
        },
        (error) => {
          console.error('Failed to fetch regions:', error);
          this.regionsLoading = false;
        }
      );
  }

  onRegionChange() {
    const regionObj = this.complaintsForm.get('region')?.value;
    if (regionObj) {
      this.fetchExchanges(regionObj.APP_MANAGEMENT_CENTER_OBJ_NUM);
    } else {
      this.exchanges = [];
      this.complaintsForm.get('exchange')?.setValue('');
    }
  }

  fetchExchanges(regionObjNum: number) {
    this.exchangesLoading = true;
    this.http.get(`${exchangeUrl}${regionObjNum}`)
      .subscribe(
        (response: any) => {
          this.exchanges = response.data || [];
          this.exchangesLoading = false;
        },
        (error) => {
          console.error('Failed to fetch exchanges:', error);
          this.exchangesLoading = false;
        }
      );
  }

  onButtonClick() {
    this.showPopup = true;
    document
      .querySelector('.complaints-button')
      ?.classList.replace('button-visible', 'button-hidden');
    document
      .querySelector('.complaints-modal')
      ?.classList.replace('modal-hidden', 'modal-visible');
  }

  onCancelClick() {
    this.showPopup = false;
    document
      .querySelector('.complaints-button')
      ?.classList.replace('button-hidden', 'button-visible');
    document
      .querySelector('.complaints-modal')
      ?.classList.replace('modal-visible', 'modal-hidden');
  }

  generateReferenceNumber(): string {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 1000);
    return `COMP-${timestamp.toString().substring(5)}-${random}`;
  }

  onSubmit() {
    if (this.complaintsForm.valid) {
      const formData = this.complaintsForm.value;
      const selectedRegion = formData.region;

      // Generate a unique reference number for this complaint
      this.complaintReference = this.generateReferenceNumber();

      // Prepare the payload matching the server expectations
      const complaintsData = {
        appId: '3', // Careers Platform
        platform: 'E-Recruitment',
        name: formData.accountName,
        email: formData.email,
        landline: formData.landlineNumber || '',
        cellnumber: formData.mobileNumber,
        message: formData.customerFeedback,
        region: selectedRegion ? selectedRegion.LONG_NAME : '',
        exchange: formData.exchange || '',
        // referenceNumber: this.complaintReference,
      };

      console.log('Submitting complaint data:', complaintsData);

      this.loading = true;
      this.isSending = true;

      // Submit the complaint to the backend
      this.http.post(`${complaintsUrl}`, complaintsData).subscribe({
        next: (response: any) => {
          console.log('Complaint submitted successfully', response);
          this.loading = false;
          this.isSending = false;

          // Reset form and close popup
          this.complaintsForm.reset();
          this.showPopup = false;

          proToast.fire({
            icon: 'success',
            title: 'Your complaint has been submitted successfully!',
            customClass: {
              container: 'higher-z-index-toast',
            },
          });
        },
        error: (error: any) => {
          this.loading = false;
          this.isSending = false;
          this.handleError(error, 'Failed to submit complaint');
        }
      });
    } else {
      // Mark all form controls as touched to trigger validation messages
      Object.keys(this.complaintsForm.controls).forEach((field) => {
        const control = this.complaintsForm.get(field);
        control!.markAsTouched({ onlySelf: true });
      });
    }
  }

  handleError(error: any, message: string) {
    this.loading = false;
    this.isSending = false;
    console.error(message, error);

    proToast.fire({
      icon: 'error',
      title: 'Oops! Something went wrong.',
      text: `${message}. Please try again later.`,
      customClass: {
        container: 'higher-z-index-toast',
      },
    });
  }
}
